<template>
	<div>
		<el-tabs type="border-card" v-model="activeName">
			<el-tab-pane name='first' label="用户" id="users_tab">
				<!--div-- class="search-input">
					<el-input clearable v-model="input" placeholder="Email" style="width:200px;"></el-input>
                    <el-button type="primary" style="margin-left: 15px;" @click.native="handleUserSearch" >查找</el-button>
                    <el-button type="primary" icon="search" @click.native.prevent="handleUserSearch">查找</el-button>
				</div-->
                <el-col :span="24" class="toolbar" align="left">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item>
                            <el-input v-model="formInline.Email" placeholder="邮箱"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" style="width: 120px" icon="el-icon-search" @click.native.prevent="handleUserSearch">查找</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
				<el-table :data="currentTableData" stripe border style="width: 100%;">
					<div v-for="(item,index) in tabInformation" :key="index">
						<el-table-column :prop="item.prop" :label="item.label" :width="item.width" sortable></el-table-column>
					</div>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<!--el-button size="mini" type="primary" icon="el-icon-edit" v-show="seen(scope.$index)" @click="handleUserModify(scope.$index)"></el-button-->
							<el-button size="mini" type="danger" icon="el-icon-delete" v-show="seen(scope.$index)" @click="handleUserDelete(scope.$index)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				<!--分页-->
			    <el-col :span="24" class="toolbar">
					<el-pagination
			            :page-sizes="pageSizes"
                        :current-page="pageIndex"
                        :page-size="pageSize"
			            layout="total, prev, pager, next"
			            :total="totaltotal"
                        v-on:current-change="pageIndexChange"
                        v-on:size-change="sizeChange"
			            style="margin-top:20px">
			        </el-pagination>
			    </el-col>
				<!-- 修改用户界面 -->
				<el-dialog title="修改用户" :visible.sync="userFormVisible" class='modify' width='450px'>
					<el-form :model="userForm">
						<el-form-item label="邮箱" :label-width="formLabelWidth">
							<el-input v-model="userForm.email" auto-complete="off" style="width: 350px" :disabled="true"></el-input>
						</el-form-item>
						<el-form-item label="部门" :label-width="formLabelWidth">
							<el-select v-model="userForm.apartment" auto-complete="off" style="width: 350px">
								<el-option label="电视应用所" value="电视应用所"></el-option>
								<el-option label="基础软件所" value="基础软件所"></el-option>
								<el-option label="SQA测试部" value="SQA测试部"></el-option>
								<el-option label="TV+" value="TV+"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="角色" :label-width="formLabelWidth">
							<el-select v-model="userForm.role" placeholder="请选择角色" style="width: 350px">
								<el-option label="admin" value="admin"></el-option>
								<el-option label="user" value="user"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button @click="userFormVisible = false">取 消</el-button>
						<el-button type="primary" @click="submitUserModifyForm('userForm')">提 交</el-button>
					</div>
				</el-dialog>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>

import { mapState } from 'vuex'
import { Config } from '@/config/config'
import Notify from '../../api/notifyMsg'

var tableData = []
var limitedTableData = []
var paginationData = []

export default {
    name: 'User',
    computed: mapState({
        user: state => state.user
    }),
    components: {

    },
    data() {
        return {
            formInline: {
                Email: ''
            },
            tabInformation: [
                {
                    prop: 'role',
                    label: '角色',
                    width: '300'
                },
                {
                    prop: 'email',
                    label: '邮箱',
                    width: '300'
                },
            ],

            currentTableData: [],
            pageIndex: 1,
            pageSizes: [10, 20, 30, 40, 50],
            pageSize: 10,
            totaltotal: 0,
            userFormVisible: false,
            userForm: {
                email: '',
                role: '',
                apartment: ''
            },
            formLabelWidth: '40px',
            activeName: 'first',
            input: ''
        }
    },
    mounted() {
        // this.getApartmentData()
        this.updateHeader();
        this.getUserData()
    },
    methods: {
        seen(index) {
            //console.log("user:", this.user, " role:", this.user.Role)
            if (this.currentTableData[index].email !== this.user.email && this.user.Role === "admin") {
                return true
            } else {
                return false
            }
        },
        updateHeader() {
            document.getElementById("title_username").innerHTML = this.user.email;
        },
        pageIndexChange(pageIndex) {
            var _this = this
            _this.pageIndex = pageIndex
            this.getUserData()
        },
        sizeChange(pageSize) {
            var _this = this
            _this.pageSize = pageSize
            this.getUserData()
        },
        /*pagination() {
            this.currentTableData = []
            var startIndex = (this.pageIndex - 1) * this.pageSize
            var currentPageMaxItemsSize = ((startIndex + this.pageSize) > (this.totaltotal - startIndex)) ? (this.totaltotal - startIndex) : (startIndex + this.pageSize)
            for (var a = startIndex, b = 0; a < currentPageMaxItemsSize + startIndex, b < currentPageMaxItemsSize; a++, b++) {
                this.currentTableData[b] = paginationData[a]
            }
        },*/
        handleUserModify(index) {
            // this.userForm.email = tableData[(this.pageIndex - 1) * this.pageSize + index].email
            // this.userForm.role = tableData[(this.pageIndex - 1) * this.pageSize + index].role
            // this.userForm.apartment = tableData[(this.pageIndex - 1) * this.pageSize + index].apartment
            this.userForm.email = this.currentTableData[index].email
            this.userForm.role = this.currentTableData[index].role
            this.userForm.apartment = this.currentTableData[index].apartment
            this.userForm.id = this.currentTableData[index].id
            this.userForm.username = this.currentTableData[index].username
            this.userFormVisible = true
        },
        handleUserDelete(index) {
            var _this = this;
            _this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    console.log(_this.currentTableData[index].id)
                    fetch(Config.url + "/api/v1/users/" + _this.currentTableData[index].id + "?token=" + _this.user.token, {
                        "method":"DELETE"
                    })
                    .then(response => response.json())
                    .then(json => {
                        console.log(json)
                        if (json.Error_code === 1000) {
                            _this.getUserData()
                            _this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        } else {
                            Notify.errMsgNotify(json.Error_code, this)
                            return
                        }
                    })
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        handleUserSearch() {
            var _this = this;
            console.log(_this.formInline.Email);
            _this.getUserData();
        },
        getUserData() {
            var _this = this;
            _this.currentTableData = [];
            var offset = (_this.pageIndex - 1) * _this.pageSize;
            var keyword = _this.formInline.Email;
            console.log("getUserData user:", _this.user);
            fetch(Config.url + "/api/v1/users?token=" + _this.user.token + "&offset=" + offset + "&limit=" + _this.pageSize + "&keyword=" + keyword, {
                "method":"GET"
            })
            .then(response => response.json())
            .then(json => {
                console.log(json)
                if (json.Error_code === 1000) {
                    if (json.Users_info.length > 0) {
                        for (var i = 0; i < json.Users_info.length ; i++) {
                            var email = json.Users_info[i].Email
                            var apartment = json.Users_info[i].Department
                            var role = json.Users_info[i].Role
                            var id = json.Users_info[i].Id
                            var username = json.Users_info[i].Nickname
                            //tableData[i] = new this.showUser(email, apartment, role, id, username)
                            _this.$set(_this.currentTableData, i, new this.showUser(email, apartment, role, id, username))
                        }
                        _this.totaltotal = json.Users_info.length;
                    }
                } else {
                    Notify.errMsgNotify(json.Error_code, this)
                    return
                }
            })
        },
        showUser(email, apartment, role, id, username) {
            this.email = email;
            this.apartment = apartment;
            this.role = role;
            this.id = id;
            this.username = username;
        },
        submitUserModifyForm(formName) {
            var _this = this
            var modifyReq = new Request(Config.url + "/api/v1/users/" + this.user.UID + "?token=" + this.user.token, {
                method: "PUT",
                body: JSON.stringify(
                {
                    "Id": _this.userForm.id,
                    "UserName": _this.userForm.username,
                    "Email": _this.userForm.email,
                    "Role": _this.userForm.role,
                    "Department": _this.userForm.apartment
                    // "email": _this.addForm.email,
                    // "Department": _this.addForm.apartment
                })
            });

            // fetch(Config.url + "/api/v1/users/:" + this.user.UID + "?token=" + this.user.token, fetchOptions)
            fetch(modifyReq)
            .then(response => response.json())
            .then(json => {
                // console.log(json)
                if (json.Error_code === 1000) {
                    this.getUserData()
                    _this.$message({
                        type: 'success',
                        message: '修改用户成功！'
                    });
                } else {
                    console.log("error!")
                    Notify.errMsgNotify(json.Error_code, this)
                    return
                }
            })
            _this.userFormVisible = false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/User.vue